import { Injectable } from '@angular/core';
import { QueryEntity } from '@datorama/akita';
import { PdfReportStore, PdfReportState } from './pdf-report.store';

@Injectable({ providedIn: 'root' })
export class PdfReportQuery extends QueryEntity<PdfReportState> {
    constructor(protected store: PdfReportStore) {
        super(store);
    }

    /**
     * context$
     * @description Observable for the context of the PDF report
     */
    context$ = this.select((state) => ({
        context: state.context
    }));

    /** orientation$
     * @description Observable for the orientation of the PDF report
     */
    orientation$ = this.select((state) => state.orientation);
    get orientation() {
        return this.getValue().orientation;
    }

    /** exportModalIsActive$
     * @description Observable for the state of the PDF report export modal, true when the modal is open
     */
    exportModalIsActive$ = this.select((state) => state.ui.active);
    all$ = this.selectAll({ sortBy: 'order' });
}
